<template>
  <section class="stands-section" ref="section">
    <Header id="foyer2DHeader" :notificationIconClass="notificationIconClass" :playProfileNotification="playProfileNotification" :openChannelId="channelId" v-if="!hideHeader" />
    <map name="standsImageMap" ref="standsImageMap" class="stands-area-and-overlay-items" v-dragscroll.pass="enableScroll">
      <img usemap="#standsImageMap" :class="{ isHideHeader: hideHeader }" class="stands-background-image" ref="imageBase" :src="stands.image" alt @load="onBaseImageLoaded" />
      <div v-for="area in stands.areas" :key="area.title">
        <!-- AREA -->
        <area href="#" :coords="area.coords" shape="rect" :title="area.title" @click.prevent="baseClicked" />

        <!-- OVERLAY -->
        <div
          :id="area.title"
          class="stands-overlay-item"
          :class="{ isHideHeader: hideHeader }"
          :style="{
            justifyContent: activityData.property.foyer2DInfospotAlign,
            alignItems: activityData.property.foyer2DInfospotJustify,
            color: activityData.property.foyer2DHintTextColor,
            borderRadius: activityData.property.foyer2DHintBorderRadius,
          }"
          @click.prevent="overlayClicked(area)"
          v-if="activityData.property.foyer2DInfospot">
          <span class="overlay-item-wrapper" :style="{ justifyContent: activityData.property.foyer2DInfospotAlign, alignItems: activityData.property.foyer2DInfospotJustify }">
            <div class="overlay-item-bubble" :style="{ color: activityData.property.foyer2DHintTextColor, background: activityData.property.foyer2DHintBGColor, borderRadius: activityData.property.foyer2DHintBorderRadius }" v-if="area.hint">
              <span v-html="area.hint"></span>
            </div>
            <div class="overlay-infospot" v-if="baseImageLoaded">
              <i
                :class="`${activityData.property.foyer2DInfospotFAIconClass ? activityData.property.foyer2DInfospotFAIconClass : 'far fa-dot-circle'} infospot-fa`"
                :style="{ color: activityData.property.foyer2DInfospotColor, fontSize: activityData.property.foyer2DInfospotFAIconSize }"></i>
            </div>
          </span>
        </div>
      </div>
    </map>
    <!-- VISITED CHECKMARK -->
    <div class="visited" v-if="showCheckmarks">
      <div class="visited-checkmark" v-for="(checkmark, key) in visited" :key="key" ref="checkmarks" :id="'id' + key"></div>
    </div>
    <!-- STAND POPUP -->
    <!-- <transition appear name="fade"> -->
    <div class="stand-popup-container" v-if="showPopup && hasPopUp">
      <div class="stand-html-object-container" :class="{ animateNextStand: animateNextStand, animatePreviousStand: animatePreviousStand }" v-if="false">
        <!-- <div class="stand-html-object-item" v-for="item in 5" :key="item">ITEM</div> -->
        <div class="stand-html-object-item">ITEM</div>
        <div class="stand-html-object-item"><iframe src="https://www.youtube.com/embed/w96QFBmYPlA" frameborder="0"></iframe></div>
        <div class="stand-html-object-item">ITEM</div>
        <div class="stand-html-object-item">ITEM</div>
        <div class="stand-html-object-item">ITEM</div>
        <div class="stand-html-object-item">ITEM</div>
        <div class="stand-html-object-item">ITEM</div>
        <div class="stand-html-object-item">ITEM</div>
      </div>
      <!-- IFRAME OPTION -->
      <iframe style="margin: 116px auto auto; width: 80%; aspect-ratio: 16/9; z-index: 1" v-if="stand.image ? stand.image.endsWith('html') : false" :src="stand.image" frameborder="0"></iframe>

      <!-- IMAGE MAP OPTION -->
      <map :name="`standImageMap`" ref="standImageMap" class="stand-area-and-overlay-items" :class="{ animateNextStand: animateNextStand, animatePreviousStand: animatePreviousStand }" v-if="!stand.image.endsWith('html')">
        <video class="stand-background-image" :style="{ display: stand.videoBG ? 'unset' : 'none' }" preload="auto" loop autoplay :src="stand.videoBG"></video>
        <img :style="{ visibility: stand.image ? 'auto' : 'auto' }" :usemap="`#standImageMap`" class="stand-background-image" ref="standImage" :src="stand.image" @load="onSubImageLoaded" />
        <div v-for="area in stand.areas" :key="area.title">
          <area href="#" :coords="area.coords" shape="rect" :title="area.title" @click.prevent="subClicked" />
          <!-- OVERLAY -->
          <div :id="area.title" class="stand-overlay-item" @click="subClicked({ target: { title: area.title } })" v-if="activityData.property.foyer2DInfospot">
            <span style="position: absolute; top: 6px; right: 6px; z-index: 10" v-if="area.thumbnail && isItemInCart(area)">
              <router-link :to="{ name: 'Cart' }"><i title="Ver sacola" class="fas fa-star" style="font-size: 1rem"></i></router-link>
            </span>
            <span style="position: absolute; top: 6px; left: 6px; z-index: 1" v-if="area.thumbnail && !isItemInCart(area)">
              <i title="Adicionar à sacola" class="far fa-star" style="font-size: 1rem" @click.stop="apiPostCart(area)" v-if="!area.thumbPicker && area.thumbnail != 'ok'"></i>
              <router-link :to="{ name: 'Cart' }"><i title="Ver sacola" class="fas fa-star" style="font-size: 1rem" v-if="!area.thumbPicker && area.thumbnail == 'ok'"></i></router-link>
              <SpinnerButton v-if="area.thumbPicker && area.thumbnail != 'ok'" />
            </span>
            <div class="stand-overlay-item-area-hint" :style="{ opacity: area.hintOnHover ? '0' : '1' }" v-html="area.hint" v-if="area.hint"></div>
            <div style="width: 100%; height: 100%" v-if="area.image">
              <img style="width: 100%; height: 100%" :src="area.image" />
            </div>
          </div>
        </div>
      </map>

      <!-- CLOSE -->
      <div class="stand-close-btn" @click.prevent="showPopup = false">
        <i
          class="fas fa-times-circle"
          :style="{
            marginRight: '4px',
            color: activityData.property.foyer2DNavigationColor ? activityData.property.foyer2DNavigationColor : '#ffffff80',
            boxShadow: '0 0 6px 0 #404040',
            background: activityData.property.foyer2DNavigationBgColor,
            borderRadius: '50%',
            border: '1px solid white',
          }"></i>
      </div>

      <!-- PREVIOUS -->
      <div class="stands-previous-btn" @click.prevent="previousStand" v-if="activityData.property.foyer2DNavigation">
        <i
          class="fas fa-chevron-circle-left"
          :style="{
            background: activityData.property.foyer2DNavigationBgColor,
            color: activityData.property.foyer2DNavigationColor ? activityData.property.foyer2DNavigationColor : '#ffffff80',
            boxShadow: '0px 0px 10px 0 #000000aa',
            border: '1px solid white',
            borderRadius: '50%',
          }"></i>
      </div>
      <!-- NEXT -->
      <div class="stands-next-btn" @click.prevent="nextStand" v-if="activityData.property.foyer2DNavigation">
        <i
          class="fas fa-chevron-circle-right"
          :style="{
            background: activityData.property.foyer2DNavigationBgColor,
            color: activityData.property.foyer2DNavigationColor ? activityData.property.foyer2DNavigationColor : '#ffffff80',
            boxShadow: '0px 0px 10px 0 #000000aa',
            border: '1px solid white',
            borderRadius: '50%',
          }"></i>
      </div>
    </div>
    <!-- </transition> -->

    <!-- DETAILS POPUP -->
    <div class="stand-details-container" v-if="showDetails && hasPopUp">
      <iframe class="stand-details-video-iframe" v-if="details.video" :src="details.video" frameborder="0" allow="autoplay; encrypted-media;" allowfullscreen></iframe>
      <media-display class="stand-details-gallery" :autoPlay="false" :wheelControl="true" :mouseDrag="true" :trimWhiteSpace="true" v-if="details.images ? details.images.length : false" v-focus>
        <media-slide v-for="(image, key) in details.images" :key="key">
          <img class="stand-gallery-image" :src="image.url" @click="imageDisplayHandler(details.images)" />
        </media-slide>
        <media-navigation slot="hooper-addons" v-if="details.images"></media-navigation>
        <media-pagination slot="hooper-addons" v-if="details.images"></media-pagination>
      </media-display>
      <div class="checkmark-feedback" v-if="details.checkmark === true">
        <ion-icon name="checkmark-circle-outline" class="success"></ion-icon>
        <br />
      </div>
      <div class="stand-details-close-btn" @click.prevent="showDetails = false"><ion-icon name="close-circle"></ion-icon></div>
    </div>
    <div class="footer-wrapper">
      <img class="foyer2d-instructions" :src="imageHelp" v-if="imageHelp" alt />
      <Footer v-if="!externalStream" />
    </div>
  </section>
</template>
<script>
import Header from '@/components/general/Header.vue';
import Footer from '@/components/general/Footer.vue';
import api from '@/services/api.js';
import Cart from '@/views/Cart.vue';
import SpinnerButton from '@/components/ui/SpinnerButton.vue';

import { dragscroll } from 'vue-dragscroll';
import { Hooper as MediaDisplay, Slide as MediaSlide, Navigation as MediaNavigation, Pagination as MediaPagination } from 'hooper';

export default {
  name: 'Areas',
  components: {
    Header,
    Footer,
    Cart,
    SpinnerButton,
    MediaDisplay,
    MediaSlide,
    MediaNavigation,
    MediaPagination,
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.focus();
      },
    },
    dragscroll,
  },
  props: ['externalStream', 'standFromLink'],
  data() {
    return {
      stands: [], //standsJSON
      stand: {},
      details: {},
      visited: [],
      visitedTemp: [],
      deltaXSum: 0,
      deltaYSum: 0,
      hasPopUp: false,
      showPopup: false,
      showDetails: false,
      enableScroll: false,
      standsNaturalImageMapCoords: [],
      standNaturalImageMapCoords: [],
      activityData: { images: {}, interactivities: [] },
      title: '',
      hideHeader: true,
      showCheckmarks: true,
      checkmarksCollection: [],
      uniqueCheckmarksCollection: [],
      activeStand: '',
      imageHelp: '',
      animateNextStand: false,
      animatePreviousStand: false,
      baseImageLoaded: false,
      subImageLoaded: false,
      nextClicked: false,
      previousClicked: false,
      useFoyer2DNavigationAnimation: false,
      baseOverlaysHTMLCollection: null,
      popupOverlaysHTMLCollection: null,
      overlays: null,
      imageFull: null,
      showImageFull: false,
      userCart: [],
      notificationIconClass: '',
      playProfileNotification: false,
      channelId: '',
    };
  },
  watch: {
    $route() {
      this.loadActivity();
      this.showPopup = false;
      this.showDetails = false;
    },
  },
  methods: {
    loadActivity() {
      api
        .get(`activity/${this.externalStream ? this.externalStream : this.$route.params.stream}`)
        .then((response) => {
          //console.log(response);

          let tempImages = { ...this.activityData.images };
          this.activityData = { ...this.activityData, ...response.data };
          this.activityData.images = response.data.images ? JSON.parse(response.data.images) : tempImages;

          let tempProperty = { ...this.activityData.property };
          this.activityData.property = response.data.property ? JSON.parse(response.data.property) : tempProperty;

          // response.data.interactivity.forEach((item) => {
          //   this.activityData.interactivities[item.interactivity] = item.enable;
          // });

          this.title = this.activityData.activity;
          this.imageHelp = this.activityData.property.imageHelp ? this.activityData.property.imageHelp : this.imageHelp;
          this.hideHeader = this.activityData.property.hideHeader ? true : false;
          if (this.externalStream) this.hideHeader = true;
          if (this.activityData.property.foyer2DNavigationAnimation) this.useFoyer2DNavigationAnimation = true;
          // console.log('activity: ', this.activityData);
        })
        .then(() => {
          this.hasPopUp = this.activityData.property.hasPopUp;
          this.stands = this.activityData.property.foyer2D ? this.activityData.property.foyer2D : this.activityData.property;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    onBaseImageLoaded() {
      // console.log('BASE IMAGE LOADED');
      this.initBaseImageMap('standsImageMap');
      this.resizeBaseImageMap();
      setTimeout(() => {
        this.baseImageLoaded = true;
        if (this.standFromLink) {
          this.baseClicked({ target: { title: this.standFromLink } });
        }
      }, 700);
    },
    onSubImageLoaded() {
      this.initSubImageMap('standImageMap');
      this.resizeStandImageMap();
      this.subImageLoaded = true;

      if (this.nextClicked) {
        this.nextClicked = false;
        this.animateNextStand = true;
        // console.log('SUB IMAGE LOADED:', this.subImageLoaded);
        // console.log('animateNextStand', this.animateNextStand);
        setTimeout(() => {
          this.animateNextStand = false;
          // console.log('animateNextStand', this.animateNextStand);
        }, 500);
      }
      if (this.previousClicked) {
        this.previousClicked = false;
        this.animatePreviousStand = true;
        // console.log('SUB IMAGE LOADED:', this.subImageLoaded);
        setTimeout(() => {
          this.animatePreviousStand = false;
        }, 500);
      }
    },
    baseClicked(e) {
      if (!this.hasPopUp) {
        this.details = this.stands.areasObjects[e.target.title];
        this.showDetails = true;
        // console.log('baseClicked');
        this.$nextTick(() => {
          if (e.target.title == 'AJUDA') {
            // console.log('AJUDA!!!!: ' + JSON.stringify(e.target.title));
            alert(`Olá, para iniciar o evento e entrar em sua reunião, você deve clicar na unidade de negócios de sua franquia e escolher o horário e data pertinentes ao momento.
Caso precise de alguma informação ou ajuda, é só entrar em contato pelo email: suporte.ache@convencaoache2021.com.br ou pelo Whatsapp: +55 11 99498-9791`);
          } else if (e.target.title == 'ATIVIDADES LIVRES') {
            if (
              confirm(`Olá Geração Aché!
Nosso espaço de atividades livres foi criado pensando única e exclusivamente em seu entretenimento. Todos os conteúdos oferecidos aqui são de lazer e livre participação, sendo independentes dos conteúdos oficiais apresentados em agenda durante a Convenção de Vendas 2021 e não exigem a sua participação.
Se você concorda, clique em ok e divirta-se!`)
            ) {
              this.$router.push(this.details);
              // console.log('YES.');
            } else {
              // Do nothing!
              // console.log('NO.');
            }
          } else {
            if (this.details.name) {
              this.showDetails = false;
              this.$router.push(this.details);
            }
            if (this.details.url) {
              window.open(this.details.url);
              this.details.url = null;
              this.showDetails = false;
            }
          }
        });
      } else {
        this.currentStandTitle = e.target.title;
        this.activeStand = e.target.title;
        this.stand = this.stands.areasObjects[e.target.title];
        this.details = this.stands.areasObjects[e.target.title];

        if (this.details.name) {
          this.showDetails = true;
          this.showDetails = false;
          this.$router.push(this.details);

          api.post(`sessionAction/`, {
            action: 'Foyer2D Action - Open Route',
            properties: JSON.stringify({ activity_id: this.$route.params.stream, destination: this.details.params.stream }),
            userid: this.$store.state.user.id,
            sessionid: this.$store.state.user.token,
            event_id: this.$store.state.eventId,
          });
        } else if (this.details.url) {
          window.open(this.details.url);

          api.post(`sessionAction/`, {
            action: 'Foyer2D Action - Open URL',
            properties: JSON.stringify({ activity_id: this.$route.params.stream, url: this.details.url }),
            userid: this.$store.state.user.id,
            sessionid: this.$store.state.user.token,
            event_id: this.$store.state.eventId,
          });
          // this.details.url = null;
          this.showDetails = false;
        } else {
          this.$nextTick(() => {
            this.showPopup = true;
            api.post(`sessionAction/`, {
              action: 'Foyer2D Action - Open Stand',
              properties: JSON.stringify({ activity_id: this.$route.params.stream, stand: this.activeStand, id: this.stand.id }),
              userid: this.$store.state.user.id,
              sessionid: this.$store.state.user.token,
              event_id: this.$store.state.eventId,
            });
            // window.scrollTo(0, 0);
          });
        }
      }
    },
    subClicked(e) {
      // console.log('subClicked:', { e });

      this.details = this.stand[e.target.title];
      this.showDetails = true;

      // console.log('subClicked:', e.target.title, this.details);

      api.post(`sessionAction/`, {
        action: 'Foyer2D Action - Sub',
        properties: JSON.stringify({ activity_id: this.$route.params.stream, stand: this.activeStand, item: e.target.title, ref: this.activeStand + '-' + e.target.title, details: this.details }),
        userid: this.$store.state.user.id,
        sessionid: this.$store.state.user.token,
        event_id: this.$store.state.eventId,
      });

      this.$nextTick(() => {
        if (this.details.checkmark && this.details.checkmark != 'false' && !this.details.url) {
          // console.log('CHECKMARK: ' + this.activeStand);
          this.showDetails = false;
          this.openChannel(this.details.checkmark);
        } else if (this.details.url) {
          // console.log('details: ', this.details);
          window.open(this.details.url);
          this.showDetails = false;
          // this.details.url = null;
        } else if (this.details.name && !this.details.url) {
          this.showDetails = false;
          if (this.details.name != 'MENSAGEM') {
            this.$router.push({ name: this.details.name, params: this.details.params ? this.details.params : '' });
          }
        }
      });
    },
    overlayClicked(area) {
      this.baseClicked({ target: { title: area.title } });
    },
    initBaseImageMap(areasRef) {
      let areas = this.$refs[areasRef].getElementsByTagName('area');
      let coords = [];
      for (let n = 0; n < areas.length; n++) {
        coords[n] = areas[n].coords.split(',');
      }
      this.standsNaturalImageMapCoords = coords.slice();
    },
    resizeBaseImageMap() {
      let coords = JSON.parse(JSON.stringify(this.standsNaturalImageMapCoords));
      let areas = this.$refs.standsImageMap.getElementsByTagName('area');
      // console.log({ areas });

      this.baseOverlaysHTMLCollection = this.$refs.standsImageMap.getElementsByClassName('stands-overlay-item');
      // console.log({ this.baseOverlaysHTMLCollection });

      let ratio = this.$refs.imageBase.width / this.$refs.imageBase.naturalWidth;
      // console.log("imageBase width: ", this.$refs.imageBase.width )
      for (let n = 0; n < areas.length; n++) {
        let coordsLenght = coords[n].length;
        for (let m = 0; m < coordsLenght; m++) {
          coords[n][m] *= ratio;
        }
        areas[n].coords = coords[n].join(',');
        // console.log(areas[n].coords.split(','));

        if (this.activityData.property.foyer2DInfospot) {
          this.baseOverlaysHTMLCollection[n].style.bottom = `${areas[n].coords.split(',')[3]}px`;
          this.baseOverlaysHTMLCollection[n].style.top = `${areas[n].coords.split(',')[1]}px`;
          this.baseOverlaysHTMLCollection[n].style.left = `${areas[n].coords.split(',')[0]}px`;
          // this.baseOverlaysHTMLCollection[n].style.right = `${areas[n].coords.split(',')[2]}px`;
          this.baseOverlaysHTMLCollection[n].style.width = `${areas[n].coords.split(',')[2] - areas[n].coords.split(',')[0]}px`;
          this.baseOverlaysHTMLCollection[n].style.height = `${areas[n].coords.split(',')[3] - areas[n].coords.split(',')[1]}px`;
        }
      }

      let overlays = Array.from(this.baseOverlaysHTMLCollection);
      this.overlays = overlays.map((el) => {
        // console.log('el', el);
        let item = {
          ratio: ratio,
          title: el.id,
          top: el.style.top.substring(0, el.style.top.length - 2) * 1,
          left: el.style.left.substring(0, el.style.left.length - 2) * 1,
          width: el.style.width.substring(0, el.style.width.length - 2) * 1,
          height: el.style.height.substring(0, el.style.height.length - 2) * 1,
        };
        return item;
      });

      // console.log('window.scrollTo', this.$refs.section.scrollHeight);
      // window.scrollTo(0, this.$refs.section.scrollHeight / 2 - 100);

      // SCROLL TO MIDDLE ON MOBILE
      this.$nextTick(() => {
        this.$refs.standsImageMap.scrollTop = this.$refs.section.scrollHeight / 2 - 100;
        this.$refs.standsImageMap.scrollLeft = (1920 - document.body.clientWidth) / 2;
        if (window.innerWidth > 706) {
          this.enableScroll = false;
        } else {
          this.enableScroll = true;
        }
        if (this.$refs.standImageMap) this.resizeStandImageMap();
      });

      // setTimeout(() => {
      //   window.scrollTo(0, this.$refs.section.scrollHeight / 2 - 100);
      // }, 2000);
    },
    initSubImageMap(areasRef) {
      let areas = this.$refs[areasRef].getElementsByTagName('area');
      let coords = [];
      for (let n = 0; n < areas.length; n++) {
        coords[n] = areas[n].coords.split(',');
      }
      this.standNaturalImageMapCoords = coords.slice();
    },
    resizeStandImageMap() {
      let coords = JSON.parse(JSON.stringify(this.standNaturalImageMapCoords));
      let areas = this.$refs.standImageMap.getElementsByTagName('area');
      let ratio = this.$refs.standImage.width / this.$refs.standImage.naturalWidth;

      this.popupOverlaysHTMLCollection = this.$refs.standImageMap.getElementsByClassName('stand-overlay-item');

      for (let n = 0; n < areas.length; n++) {
        let clen = coords[n].length;
        for (let m = 0; m < clen; m++) {
          coords[n][m] *= ratio;
        }
        areas[n].coords = coords[n].join(',');

        // this.popupOverlaysHTMLCollection[n].style.marginTop = `${100}px`;
        this.popupOverlaysHTMLCollection[n].style.bottom = `${areas[n].coords.split(',')[3]}px`;
        this.popupOverlaysHTMLCollection[n].style.top = `${areas[n].coords.split(',')[1]}px`;
        this.popupOverlaysHTMLCollection[n].style.left = `${areas[n].coords.split(',')[0]}px`;
        // popupOverlaysHTMLCollection[n].style.right = `${areas[n].coords.split(',')[2]}px`;
        this.popupOverlaysHTMLCollection[n].style.width = `${areas[n].coords.split(',')[2] - areas[n].coords.split(',')[0]}px`;
        this.popupOverlaysHTMLCollection[n].style.height = `${areas[n].coords.split(',')[3] - areas[n].coords.split(',')[1]}px`;
      }
    },
    screenRatioComputed(area, standArea) {
      if (document.getElementById(area.title)) {
        // console.log('screenRatioComputed image:', this.activityData.property[area.title].image, document.getElementById(area.title).clientWidth / document.getElementById(area.title).naturalWidth);
        // console.log('screenRatioComputed area:', { area });
        // console.log('screenRatioComputed standArea:', { standArea });
        return document.getElementById(area.title).clientWidth / document.getElementById(area.title).naturalWidth;
      } else return 0.58;
    },
    nextStand() {
      this.subImageLoaded = false;
      this.nextClicked = true;

      let stands = JSON.parse(JSON.stringify(this.stands));
      let standsEntries = Object.entries(stands.areasObjects);
      stands = standsEntries.filter((item) => !item[1].name);
      stands = stands.map((item) => item[0]);

      let areas = JSON.parse(JSON.stringify(this.stands.areas));
      areas = areas.filter((area) => stands.includes(area.title));
      areas = areas.sort((a, b) => (a.title > b.title ? 1 : -1));

      let entries = Object.entries(areas);
      let nextStand = '';
      let lastItem = entries.slice(-1)[0];
      let firstItem = entries.slice(0)[0];

      entries.map((area) => {
        if (this.activeStand == area[1].title) {
          if (parseInt(area[0]) == lastItem[0]) {
            nextStand = firstItem[1].title;
          } else nextStand = entries[parseInt(area[0]) + 1][1].title;
        }
      });
      this.activeStand = nextStand;
      this.stand = this.stands.areasObjects[nextStand];
      api.post(`sessionAction/`, {
        action: 'Foyer2D Action - NextStand',
        properties: JSON.stringify({ activity_id: this.$route.params.stream, stand: this.activeStand }),
        userid: this.$store.state.user.id,
        sessionid: this.$store.state.user.token,
        event_id: this.$store.state.eventId,
      });
    },
    previousStand() {
      this.subImageLoaded = false;
      this.previousClicked = true;

      let stands = JSON.parse(JSON.stringify(this.stands.areasObjects));
      let standsEntries = Object.entries(stands);
      stands = standsEntries.filter((item) => !item[1].name);
      stands = stands.map((item) => item[0]);

      let areas = JSON.parse(JSON.stringify(this.stands.areas));
      areas = areas.filter((area) => stands.includes(area.title));
      areas = areas.sort((a, b) => (a.title > b.title ? 1 : -1));

      let entries = Object.entries(areas);
      let nextStand = '';
      let lastItem = entries.slice(-1)[0];
      let firstItem = entries.slice(0)[0];

      entries.map((area) => {
        if (this.activeStand == area[1].title) {
          if (parseInt(area[0]) == firstItem[0]) {
            nextStand = lastItem[1].title;
          } else nextStand = entries[parseInt(area[0]) - 1][1].title;
        }
      });
      this.activeStand = nextStand;
      this.stand = this.stands.areasObjects[nextStand];
      api.post(`sessionAction/`, {
        action: 'Foyer2D Action - PreviousStand',
        properties: JSON.stringify({ activity_id: this.$route.params.stream, stand: this.activeStand }),
        userid: this.$store.state.user.id,
        sessionid: this.$store.state.user.token,
        event_id: this.$store.state.eventId,
      });
    },
    scrollY() {
      // console.log(this.$refs.section.scrollTop);
      // console.log(this.$refs.section.scrollHeight / 2);
      let headerHeight = document.getElementById('foyer2DHeader').offsetHeight - (window.innerHeight <= 460 ? 10 : 0);
      this.stands.areas.map((area) => {
        document.getElementById(area.title).style.marginTop = `${-this.$refs.section.scrollTop + headerHeight}px`;
      });
    },
    handlePopupKeypress(e) {
      if (this.showPopup && !this.showDetails) {
        if (e.key == 'ArrowLeft') this.previousStand();
        if (e.key == 'ArrowRight') this.nextStand();
      }
    },
    imageDisplayHandler(images) {
      // console.log(images);
      this.showImageFull = !this.showImageFull;
      this.imageFull = images;
    },
    apiGetCart() {
      api
        .get(`event/${this.$store.state.eventId}/cart`)
        .then((response) => {
          // console.log('apiGetCart response', { response });
          this.userCart = response.data;
        })
        .catch((err) => console.error(err));
    },
    apiPostCart(area) {
      area.thumbPicker = true;
      this.playProfileNotification = false;
      api
        .get(`event/${this.$store.state.eventId}/cart`)
        .then((response) => {
          // console.log('apiGetCart response', { response });
          let isNew = response.data.filter((item) => JSON.parse(item.properties).item_id == area.id && item.provider == area.title).length == 0;
          // console.log('isNew?', isNew, response.data.filter((item) => JSON.parse(item.properties).item_id == area.id).length);
          if (isNew) {
            // console.log('isNew', area);

            let payload = {
              item: area.title,
              description: area.description ? area.description : 'Description',
              provider: this.stand.name ? this.stand.name : this.stand.title ? this.stand.title : this.activityData.activity,
              category: area.type,
              image: area.thumbnail ? area.thumbnail : area.image ? area.image : 'https://i.stack.imgur.com/y9DpT.jpg',
              link: this.stand[area.title].url ? this.stand[area.title].url : this.stand[area.title].video ? this.stand[area.title].video : 'https://i.stack.imgur.com/y9DpT.jpg',
              properties: JSON.stringify({ item_id: area.id, images: JSON.stringify(this.stand[area.title].images) }),
              price: 23.9,
              quantity: 1,
              discount_item: null,
              order: 0,
            };
            api
              .post(`event/${this.$store.state.eventId}/cart`, payload)
              .then((resp) => {
                // console.log('apiPostCart response', { resp });
                area.thumbPicker = false;
                area.thumbnail = 'ok';
                this.notificationIconClass = `fa-star`;
                this.playProfileNotification = true;
              })
              .catch((err) => console.error(err));
          } else area.thumbnail = '';
        })
        .catch((err) => console.error(err));
    },
    isItemInCart(item) {
      // console.log('isItemInCart:', { item });
      let result = this.userCart.filter((cart) => cart.item == item.title && cart.provider == this.stand.title);
      // console.log('result:', result.length);

      return result.length;
    },
    openChannel(user_id) {
      // console.log('open channel selectedItem link', this.selectedItem.link);
      // this.channelId = this.selectedItem.link;

      api
        .post(`event/${this.$store.state.eventId}/createTalkChannel`, { user_id: user_id, channelName: user_id > this.$store.state.user.id ? user_id + this.$store.state.user.id : this.$store.state.user.id + user_id })
        .then((response) => {
          // console.log('createTalkChannel', { response });
          if (response.data) {
            this.$nextTick((_) => {
              this.channelId = response.data.talk_channel_id;
              document.getElementById('messagesContainer').focus();
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
  beforeMount() {
    this.loadActivity();
    this.apiGetCart();
    // console.log(this.standFromLink);
  },
  mounted() {
    window.addEventListener('resize', this.resizeBaseImageMap);
    window.addEventListener('keydown', this.handlePopupKeypress);
    this.$refs.section.addEventListener('scroll', this.scrollY);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeBaseImageMap);
    window.removeEventListener('keydown', this.handlePopupKeypress);
    this.$refs.section.addEventListener('scroll', this.scrollY);
  },
};
</script>
<style lang="scss" scoped>
.stands-section {
  position: relative;
  min-height: 100dvh;
  // background-color: var(--main-color);
  overflow-x: auto;
  overflow-y: hidden;
  @include media('<=phone-plus') {
    overflow-y: auto;
  }
}

.stands-area-and-overlay-items {
  height: 100%;
  width: 100%;
  // position: absolute;
}
.stands-overlay-item {
  // background-color: #40404040;
  cursor: pointer;
  position: absolute;
  margin-top: 99px;
  @include media('<=phone') {
    margin-top: 50px;
  }
  @media (max-height: 460px) {
    margin-top: 40px;
  }
  display: flex; //developing feature = flex
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
}
.stands-overlay-item-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  height: 100%;
}
.overlay-infospot {
  display: flex;
  justify-content: center;
  align-items: center;
  // background: red;
  width: auto;
  height: 20%;
  z-index: 0;
  animation: fade 5s infinite;
  -webkit-animation: fade 5s infinite;
  .infospot-fa {
    color: var(--main-color);
    font-size: 1.3rem;
  }
}
.stands-overlay-item-bubble {
  position: relative;
  background: var(--main-color);
  padding: 10px 20px !important;
  border-radius: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--text-color);
  text-align: center;
  opacity: 0; //opacity 0 fora anim
  transition: all 0.3s ease-in-out;
  z-index: 1;
  &:hover {
    opacity: 1;
  }
}
.stands-overlay-item:hover ~ .stands-overlay-item-bubble {
  opacity: 1;
}
.stands-overlay-item-wrapper:hover > .stands-overlay-item-bubble {
  opacity: 1;
}
@keyframes fade {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0.2;
  }
  to {
    opacity: 1;
  }
}
@-webkit-keyframes fade {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0.2;
  }
  to {
    opacity: 1;
  }
}
.visited-checkmark {
  display: none;
  position: absolute;
  background-color: green;
  height: 30px;
  width: 30px;
  @include media('<=phone-plus') {
    // visibility: hidden;
    background-color: transparent;
  }
}
.visited-experimental {
  visibility: hidden;
  position: fixed;
  // background-color: red;
  height: 300px;
  width: 300px;
}
.stands-background-image {
  margin-top: 99px;
  height: auto;
  width: 100vw;

  @include media('<=phone-plus') {
    // margin-top: 40px;
    width: 1920px;
  }
  @include media('<=phone') {
    margin-top: 40px;
  }
  @media (max-height: 460px) {
    margin-top: 40px;
  }
}
.stand-popup-container {
  position: fixed;
  top: 0px;
  left: 0;
  // bottom: -100px;
  right: 0;
  width: 100vw;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  z-index: 1;
  overflow-y: scroll;
  overflow-x: hidden;
  background: #111;
  @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
    background: none;
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
  }
}
.stand-area-and-overlay-items {
  // background: #00000080;
  width: 100%;
  height: 100%;
}
.stands-previous-btn {
  cursor: pointer;
  position: fixed;
  left: 2%;
  top: 80%;
  bottom: 50px;
  width: 60px;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  z-index: 1000;
  i {
    font-size: 3rem;
  }
}
.stands-next-btn {
  cursor: pointer;
  position: fixed;
  right: 2%;
  top: 80%;
  bottom: 50px;
  width: 60px;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  z-index: 1000;
  i {
    font-size: 3rem;
  }
}
.stand-background-image {
  // background: #00000080;
  position: relative;
  // min-height: 812px;
  max-height: 100%;
  width: 100%;
  min-width: 100vw;
  margin-top: 99px;
  object-fit: cover;
  object-position: left top;
  -webkit-transition-property: transform;
  -webkit-transition-duration: 500ms;
  transition-property: transform;
  transition-duration: 500ms;
}
.stand-html-object-container {
  position: fixed;
  background: #40404080;
  top: 120px;
  width: 92vw;
  height: 80%;
  border-radius: 10px;
  padding: 16px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  align-content: stretch;
  // z-index: 1;
  overflow: auto;
  gap: 10px;
  &::-webkit-scrollbar {
    background-color: transparent;
    width: 0px;
  }
  &::-webkit-scrollbar-track {
    background-color: var(--card-scrollbarBgColor);
    border-radius: var(--card-scrollbarBorderRadius);
  }
  &::-webkit-scrollbar-thumb {
    background-color: var(--card-scrollbarHandleColor) !important;
    border-radius: var(--card-scrollbarBorderRadius);
    background-image: none !important;
  }
}
.stand-html-object-item {
  position: relative;
  min-width: 300px;
  min-height: 400px;
  // max-height: 600px;
  background: #101010;
  flex-grow: 1;
  color: white;
  font-size: 2rem;
  border-radius: 10px;

  display: flex;
  justify-content: center;
  align-items: center;

  // &:hover {
  //   // transform: scale(1.02);
  // }
  &:nth-child(1) {
    background-image: url('https://s3.amazonaws.com/thumbnails.venngage.com/template/e1028a60-0b49-4238-b765-8719ce00346c.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position-x: center;
    background-position-y: center;
  }
  &:nth-child(2) {
    width: 40%;
    background: transparent;
    padding: 2% 1%;

    iframe {
      width: 100%;
      height: 100%;
    }
  }
  &:nth-child(3) {
    background: #202020;
  }
  &:nth-child(4) {
    background-image: url('https://cdn.cnn.com/cnnnext/dam/assets/190910120101-04-shopping-cities-photos.jpg');
    background-size: cover;
    min-width: 80%;
    opacity: 1;
  }
  &:nth-child(5) {
    background: transparent;
  }
  &:nth-child(6) {
    background: #000;
  }
  &:nth-child(7) {
    background: #000000bb;
  }
  &:last-child {
    min-height: 800px;
  }
}
.stand-overlay-item {
  // background-color: #40404040;
  cursor: pointer;
  position: absolute;
  margin-top: 99px;
  // margin-left: calc(72px);
  z-index: 100;

  @include media('<=phone') {
    margin-top: 50px;
  }
  @media (max-height: 460px) {
    margin-top: 50px;
  }
  // display: flex; //developing feature = flex
  // flex-direction: column;
  // justify-content: flex-end;
  // align-items: center;
  // pointer-events: none;
}
.stand-overlay-item-area-hint {
  position: absolute;
  transition: all 0.1s ease-in;
  opacity: 0;
}
.stand-overlay-item-area-hint:hover {
  opacity: 1 !important;
}
.isHideHeader {
  margin-top: 0px;
}
.success {
  color: green;
  font-size: 5rem;
}
area {
  outline: none;
}
.animatePreviousStand {
  animation: previousStand 0.5s;
}
@keyframes previousStand {
  0% {
    transform: translateX();
  }
  20% {
    transform: translateX(100vw);
  }
  21% {
    transform: translateX(-100vw);
  }
  100% {
    transform: translateX(0);
  }
}
.animateNextStand {
  animation: nextStand 0.5s;
}
@keyframes nextStand {
  0% {
    transform: translateX();
  }
  20% {
    transform: translateX(-100vw);
  }
  21% {
    transform: translateX(100vw);
  }
  100% {
    transform: translateX(0);
  }
}
.stand-details-container {
  position: fixed;
  left: 0;
  right: 0;
  top: 99px;
  bottom: 32px;
  background-color: rgba($color: black, $alpha: 0.6);
  // color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  .checkmark-feedback {
    color: var(--text-color);
    background-color: rgba($color: black, $alpha: 0.6);
    border-radius: 10px;
    position: relative;
    z-index: 2;
    width: 30vw;
    height: 10vw;
    font-size: 2vw;
    text-align: center;
    padding-top: 1.1%;
    &::after {
      content: 'Obrigado pela visita!';
    }
  }
  .stand-details-video-iframe {
    position: relative;
    z-index: 2;
    width: 80vw;
    height: 45vw;
    max-height: 80vh;
  }
  //CUSTOM GALLERY
  .image-box {
    a {
      position: relative;
      z-index: 2;
      background-color: #232323;
      // clear: both;
      display: inline-block;
      margin: 0 10px 10px 0;
      text-align: center;
      .bgbox {
        background-color: #232323;
        // height: 150px;
        display: table-cell;
        vertical-align: middle;
        padding: 4px;
        border-radius: 4px;
        img {
          width: 30vw;
          display: block;
        }
      }
      .img-title {
        display: block;
        text-align: center;
        color: #999999;
        padding: 5px 0 10px 0;
      }
      &:hover {
        .img-title {
          color: white;
        }
      }
    }
  }
}
.stand-details-gallery {
  position: fixed;
  top: 0px;
  bottom: 0px;
  z-index: 2;
  width: 84%;
  height: 90%;
  background: transparent;
}
.stand-gallery-image {
  object-fit: contain;
  width: 100%;
  height: auto;
  // margin: 120px 0;
  padding: 0 4%;

  @include media('<=tablet') {
    margin-top: 100px;
  }
}

.title {
  display: none !important;
}
.close {
  position: absolute !important;
  top: 88vh !important;
  bottom: 0px !important;
  background-color: black !important;
  width: 100vw !important;
  // transform: translateX(25px) !important;
}
.stand-close-btn {
  cursor: pointer;
  position: fixed;
  top: 100px;
  right: 0;
  background: transparent;
  // color: #ffffffc0;
  width: 100%;
  // height: 10%;
  padding: 20px;
  text-align: right;
  z-index: 1000;
  i {
    font-size: 2rem;
  }
}
.stand-details-close-btn {
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 10%;
  text-align: right;
  font-size: 2.7rem;
  // background-color: red;
  color: #ffffffc0;
  width: 100%;
  height: 100%;
  padding: 20px;
  z-index: 1;
}
.stand-background-container {
  display: flex;
  justify-content: stretch;
  width: 100%;
  min-height: 95vh;
  padding: 4% 0%;
  margin-top: 80px;
  .stands-iframe {
    flex-grow: 1;
  }
}
.foyer2d-instructions {
  display: none;
}
@include media('<=phone-plus') {
  .stand-popup-container {
    top: 100px;
  }
  .stands-area-and-overlay-items {
    overflow: scroll;
    position: absolute;
    &::-webkit-scrollbar {
      width: 0;
    }
  }
  .stand-popup-first-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-width: 40%;
    height: 100%;

    img {
      max-width: 18vw;
    }
    h2 {
      padding: 2% 0%;
    }
    .stand-description {
      font-size: 1rem;
      max-height: 260px;
      // overflow-y: auto;
    }
    .stand-btns {
      flex-wrap: wrap;
      .stand-btn {
        padding: 10px;
        // font-size: 2.4vw;
      }
    }
  }
  .stands-previous-btn {
    position: absolute;
    left: 2%;
    top: 76%;
    width: 48%;
    height: 10%;
    align-items: center;
    justify-content: center;
    i {
      font-size: 2rem;
    }
  }
  .stands-next-btn {
    position: absolute;
    top: 76%;
    width: 48%;
    height: 10%;
    align-items: center;
    justify-content: center;
    i {
      font-size: 2rem;
    }
  }
  .foyer2d-instructions {
    display: block;
    max-width: 120px;
    opacity: 0.7;
  }
  .stand-details-gallery {
    top: 50px;
  }
}
@include media('<=phone') {
  .stand-popup-container {
    top: 50px;
  }
  .stand-details-container {
    position: fixed;
    top: 50px;
  }
  .stand-close-btn {
    cursor: pointer;
    position: fixed;
    top: 34px;
    right: 0;
    background: transparent;
    color: #ffffffc0;
    width: 100%;
    height: 20%;
    padding: 20px 0px;
    text-align: right;
    font-size: 2rem;
    z-index: 1000;
  }
  .stand-background-image {
    margin-top: 50px;
  }
  .stand-popup-first-wrapper {
    // background-color: teal;
    // flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-width: 40%;
    height: 100%;
    padding-right: 5%;

    img {
      max-width: 18vw;
    }
    h2 {
      font-size: 1.2rem;

      padding: 2% 0%;
    }
    .stand-description {
      font-size: 0.8rem;
      height: 120px;
      // overflow-y: auto;
    }
    .stand-btns {
      flex-wrap: wrap;
      .stand-btn {
        padding: 10px;
        font-size: 0.6rem;
      }
    }
  }
}
@media (max-height: 460px) {
  .stands-section {
    &::-webkit-scrollbar {
      background-color: transparent;
      width: 0px;
    }
  }
  .stands-area-and-overlay-items {
    overflow-y: hidden;
  }
  .stand-background-image {
    margin-top: 50px;
  }
  .stand-popup-container {
    position: absolute;
    top: 0;
  }
  .stand-details-container {
    position: fixed;
    top: 50px;
  }
  .stand-close-btn {
    cursor: pointer;
    position: fixed;
    top: 34px;
    right: 4px;
    background: transparent;
    color: #ffffffc0;
    height: 20%;
    padding: 20px 0px;
    text-align: right;
    font-size: 2.7rem;
    z-index: 1000;
    i {
      font-size: 2.5rem;
    }
  }
  .stands-previous-btn {
    position: fixed;
    top: unset;
    left: 14px;
    bottom: 46px;
    width: unset;
    height: 10%;
    i {
      font-size: 2rem;
    }
  }
  .stands-next-btn {
    position: fixed;
    top: unset;
    left: unset;
    right: 14px;
    bottom: 46px;
    width: unset;
    height: 10%;
    i {
      font-size: 2rem;
    }
  }
  .stand-popup-first-wrapper {
    // background-color: teal;
    // flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-width: 40%;
    height: 100%;
    padding-right: 5%;

    img {
      max-width: 18vw;
    }
    h2 {
      font-size: 1.2rem;

      padding: 2% 0%;
    }
    .stand-description {
      font-size: 0.8rem;
      height: 120px;
      // overflow-y: auto;
    }
    .stand-btns {
      flex-wrap: wrap;
      .stand-btn {
        padding: 10px;
        font-size: 0.6rem;
      }
    }
  }
}
</style>
